module.exports = __webpack_public_path__ + "img/ekyc_doc_selfie.9e3c1bf7.svg";